import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'migo-apps-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss'],
})
export class InformationComponent implements OnInit, AfterViewInit {
  @ViewChild('messageArea') messageElement: ElementRef<HTMLElement> | undefined;
  type = ''
  message = '';
  title = '';
  buttonText = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.type = this.data?.type ? this.data.type : '';
    this.title = this.data?.title ? this.data.title : 'Error';
    this.message = this.data?.message
      ? this.data.message
      : 'Lo sentimos, algo salió mal. Intenta nuevamente.';
    this.buttonText = this.data?.buttonText ? this.data?.buttonText : 'Cerrar';
  }

  ngAfterViewInit() {
    this.renderer.setProperty(
      this.messageElement?.nativeElement,
      'innerHTML',
      this.message
    );
  }
}
